import React, {
  FunctionComponent,
  useState,
  useRef,
  useEffect,
  CSSProperties,
} from "react";
import {
  styled,
  Block,
  CtaButton,
  PanelHeader,
} from "../../../seenspire-library";
import { Container, IContainer } from "../Container/Container";
import { useTranslation } from "react-i18next";
import { AspectRatioBox } from "../../containers/Dashboard/Styles";
import { FormikProps } from "formik";

const Video = styled.video`
  position: absolute;
  width: 100%;
  height: 100%;
  border: 0;
`;

const Image = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  border: 0;
  object-fit: cover;
`;

export interface IPreviewConfig {
  id: string;
  accountId?: string;
  preview?: boolean;
  sourceId?: string;
  regionId?: string;
  languageId?: string;
  presentationDesignSlug?: string;
}
interface IPreviewProps extends IContainer {
  config: IPreviewConfig;
  data?: any;
  form?: FormikProps<any>;
  onSubmit: (() => void) | null;
  onCancel: () => void;
  skipInnerWrapper?: boolean;
}

const FauxPreview: FunctionComponent<
  IPreviewProps & { style?: Partial<CSSProperties>; imageSrc?: string }
> = ({ onSubmit, onCancel, config, skipInnerWrapper, imageSrc, ...props }) => {
  // An imageSrc renders a still image (e.g. the London Tube splash); otherwise
  // fall back to the default public transport preview video. See SEE-436.
  const media = imageSrc ? (
    <Image src={imageSrc} alt="" />
  ) : (
    <Video
      autoPlay
      src={`https://storage.googleapis.com/static-seenspire/assets/portals/thumbs/infotainment/Public_Transport.mp4`}
    ></Video>
  );
  return (
    <Container skipContentPadding withHeader={!!onSubmit} {...props}>
      {skipInnerWrapper ? (
        media
      ) : (
        <Block position="relative">
          {media}
          <AspectRatioBox />
        </Block>
      )}
    </Container>
  );
};

export default FauxPreview;
